// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"1e326234","856":"31835449"}[chunkId] + ".chunk.js";
};